{
  "sourire": {
    "emotion": "sourire",
    "label": "Sourire doux",
    "genome": {
      "pullUp": 0.427,
      "pullSide": 0.188,
      "lowerLid": 0.376,
      "naso": 0.13,
      "arSmile": 0.297,
      "arCheekSquint": 0.059,
      "arEyeSquint": 0.242,
      "arRollLower": 0.102
    },
    "channels": {
      "bu:MouthLeftPullUp": 0.427,
      "bu:MouthRightPullUp": 0.427,
      "bu:MouthLeftPullSide": 0.188,
      "bu:MouthRightPullSide": 0.188,
      "bu:LeftLowerLidUp": 0.376,
      "bu:RightLowerLidUp": 0.376,
      "bu:NasolabialDeepener": 0.13,
      "mouthSmileLeft": 0.297,
      "mouthSmileRight": 0.297,
      "cheekSquintLeft": 0.059,
      "cheekSquintRight": 0.059,
      "eyeSquintLeft": 0.242,
      "eyeSquintRight": 0.242,
      "mouthRollLower": 0.102
    },
    "generations": 2,
    "at": "2026-10-08T08:17:01.288Z"
  },
  "grand-sourire": {
    "emotion": "grand-sourire",
    "label": "Grand sourire",
    "genome": {
      "jawDrop": 0.441,
      "arSmile": 0.307,
      "arCheekSquint": 0.107,
      "arEyeSquint": 0.517,
      "arDimple": 0.303
    },
    "channels": {
      "bu:JawDrop": 0.441,
      "mouthSmileLeft": 0.307,
      "mouthSmileRight": 0.307,
      "cheekSquintLeft": 0.107,
      "cheekSquintRight": 0.107,
      "eyeSquintLeft": 0.517,
      "eyeSquintRight": 0.517,
      "mouthDimpleLeft": 0.303,
      "mouthDimpleRight": 0.303
    },
    "generations": 3,
    "at": "2026-10-08T08:17:27.143Z"
  },
  "rire": {
    "emotion": "rire",
    "label": "Rire",
    "genome": {
      "pullUp": 0.492,
      "upperLipUp": 0.069,
      "naso": 0.641,
      "innerBrowUp": 0.427,
      "outerBrowUp": 0.301,
      "arSmile": 0.154,
      "arEyeSquint": 0.259,
      "arJaw": 0.17,
      "arBlink": 0.245
    },
    "channels": {
      "bu:MouthLeftPullUp": 0.492,
      "bu:MouthRightPullUp": 0.492,
      "bu:UpperLipUp": 0.069,
      "bu:NasolabialDeepener": 0.641,
      "bu:LeftInnerBrowUp": 0.427,
      "bu:RightInnerBrowUp": 0.427,
      "bu:LeftOuterBrowUp": 0.301,
      "bu:RightOuterBrowUp": 0.301,
      "mouthSmileLeft": 0.154,
      "mouthSmileRight": 0.154,
      "eyeSquintLeft": 0.259,
      "eyeSquintRight": 0.259,
      "jawOpen": 0.17,
      "eyeBlinkLeft": 0.245,
      "eyeBlinkRight": 0.245
    },
    "generations": 2,
    "at": "2026-10-08T08:17:49.544Z"
  },
  "timide": {
    "emotion": "timide",
    "label": "Timide / gênée",
    "genome": {
      "lowerLipUp": 0.016,
      "lowerLid": 0.482,
      "naso": 0.334,
      "innerBrowUp": 0.356,
      "outerBrowUp": 0.384,
      "arSmile": 0.193,
      "arDimple": 0.199
    },
    "channels": {
      "bu:lowerLipUp": 0.016,
      "bu:LeftLowerLidUp": 0.482,
      "bu:RightLowerLidUp": 0.482,
      "bu:NasolabialDeepener": 0.334,
      "bu:LeftInnerBrowUp": 0.356,
      "bu:RightInnerBrowUp": 0.356,
      "bu:LeftOuterBrowUp": 0.384,
      "bu:RightOuterBrowUp": 0.384,
      "mouthSmileLeft": 0.193,
      "mouthSmileRight": 0.193,
      "mouthDimpleLeft": 0.199,
      "mouthDimpleRight": 0.199
    },
    "generations": 2,
    "at": "2026-10-08T08:17:57.779Z"
  },
  "surprise": {
    "emotion": "surprise",
    "label": "Surprise",
    "genome": {
      "outerBrowUp": 0.369,
      "arJaw": 0.137,
      "arFunnel": 0.102
    },
    "channels": {
      "bu:LeftOuterBrowUp": 0.369,
      "bu:RightOuterBrowUp": 0.369,
      "jawOpen": 0.137,
      "mouthFunnel": 0.102
    },
    "generations": 2,
    "at": "2026-10-08T08:18:06.563Z"
  },
  "tristesse": {
    "emotion": "tristesse",
    "label": "Tristesse",
    "genome": {
      "pullDown": 0.259,
      "innerBrowUp": 0.257,
      "chinDown": 0.126
    },
    "channels": {
      "bu:MouthLeftPullDown": 0.259,
      "bu:MouthRightPullDown": 0.259,
      "bu:LeftInnerBrowUp": 0.257,
      "bu:RightInnerBrowUp": 0.257,
      "bu:ChinDown": 0.126
    },
    "generations": 2,
    "at": "2026-10-08T08:18:11.889Z"
  },
  "boudeuse": {
    "emotion": "boudeuse",
    "label": "Boudeuse",
    "genome": {
      "lowerLipUp": 0.083,
      "browDown": 0.473,
      "arPress": 0.244
    },
    "channels": {
      "bu:lowerLipUp": 0.083,
      "bu:LeftBrowDown": 0.473,
      "bu:RightBrowDown": 0.473,
      "mouthPressLeft": 0.244,
      "mouthPressRight": 0.244
    },
    "generations": 2,
    "at": "2026-10-08T08:18:20.777Z"
  },
  "tendresse": {
    "emotion": "tendresse",
    "label": "Tendresse",
    "genome": {
      "lowerLid": 0.407,
      "upperLidClose": 0.17,
      "innerBrowUp": 0.275,
      "arBlink": 0.173,
      "arEyeSquint": 0.082
    },
    "channels": {
      "bu:LeftLowerLidUp": 0.407,
      "bu:RightLowerLidUp": 0.407,
      "bu:LeftUpperLidClosed": 0.17,
      "bu:RightUpperLidClosed": 0.17,
      "bu:LeftInnerBrowUp": 0.275,
      "bu:RightInnerBrowUp": 0.275,
      "eyeBlinkLeft": 0.173,
      "eyeBlinkRight": 0.173,
      "eyeSquintLeft": 0.082,
      "eyeSquintRight": 0.082
    },
    "generations": 2,
    "at": "2026-10-08T08:18:25.379Z"
  }
}